// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d5-b";
export var colorBlue = "_d5-8";
export var colorDot = "_d5-0";
export var colorDotLarge = "_d5-2";
export var colorDotSmall = "_d5-1";
export var colorGreen = "_d5-7";
export var colorGrey = "_d5-3";
export var colorOrange = "_d5-5";
export var colorPink = "_d5-a";
export var colorPurple = "_d5-9";
export var colorRed = "_d5-4";
export var colorYellow = "_d5-6";